/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchResultFromJSON, SearchResultToJSON, } from './SearchResult';
/**
 * @export
 */
export const SearchDTOTargetMarketEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const SearchDTOStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Canceled: 'CANCELED'
};
/**
 * Check if a given object implements the SearchDTO interface.
 */
export function instanceOfSearchDTO(value) {
    return true;
}
export function SearchDTOFromJSON(json) {
    return SearchDTOFromJSONTyped(json, false);
}
export function SearchDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'targetMarket': json['targetMarket'] == null ? undefined : json['targetMarket'],
        'status': json['status'] == null ? undefined : json['status'],
        'searchResults': json['searchResults'] == null ? undefined : (json['searchResults'].map(SearchResultFromJSON)),
        'totalResults': json['totalResults'] == null ? undefined : json['totalResults'],
        'completedResults': json['completedResults'] == null ? undefined : json['completedResults'],
        'failedResults': json['failedResults'] == null ? undefined : json['failedResults'],
        'heldAsinCount': json['heldAsinCount'] == null ? undefined : json['heldAsinCount'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'finishDate': json['finishDate'] == null ? undefined : (new Date(json['finishDate'])),
        'totalAsinScanned': json['totalAsinScanned'] == null ? undefined : json['totalAsinScanned'],
        'saleableAsinCount': json['saleableAsinCount'] == null ? undefined : json['saleableAsinCount'],
        'reCheckAsinCount': json['reCheckAsinCount'] == null ? undefined : json['reCheckAsinCount'],
        'totalStagedCount': json['totalStagedCount'] == null ? undefined : json['totalStagedCount'],
    };
}
export function SearchDTOToJSON(json) {
    return SearchDTOToJSONTyped(json, false);
}
export function SearchDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
        'id': value['id'],
        'name': value['name'],
        'targetMarket': value['targetMarket'],
        'status': value['status'],
        'searchResults': value['searchResults'] == null ? undefined : (value['searchResults'].map(SearchResultToJSON)),
        'totalResults': value['totalResults'],
        'completedResults': value['completedResults'],
        'failedResults': value['failedResults'],
        'heldAsinCount': value['heldAsinCount'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'finishDate': value['finishDate'] == null ? undefined : ((value['finishDate']).toISOString()),
        'totalAsinScanned': value['totalAsinScanned'],
        'saleableAsinCount': value['saleableAsinCount'],
        'reCheckAsinCount': value['reCheckAsinCount'],
        'totalStagedCount': value['totalStagedCount'],
    };
}
